/**
 * The old emergency call-ahead's emergency types (M15, ADR-0035), kept ONLY so
 * the read-only admin queue can label its legacy records. The flow itself, and
 * every call it made, was retired at the switch-over (M36-T11); its endpoints
 * answer 410. Emergency Help v2 (`api/emergencyHelp.ts`) has no symptom grid.
 */
/** Slugs as the old flow stored them; labels are presentation only. */
export type EmergencyType = { slug: string; label: string }

export const EMERGENCY_TYPES: ReadonlyArray<EmergencyType> = [
  { slug: 'chest_pain', label: 'Chest pain' },
  { slug: 'stroke', label: 'Stroke signs' },
  { slug: 'difficulty_breathing', label: 'Difficulty breathing' },
  { slug: 'unconscious', label: 'Unconscious / collapse' },
  { slug: 'seizure', label: 'Seizure' },
  { slug: 'heavy_bleeding', label: 'Heavy bleeding' },
  { slug: 'road_traffic_accident', label: 'Road traffic accident' },
  { slug: 'motorcycle_accident', label: 'Motorcycle accident' },
  { slug: 'fall_injury', label: 'Fall / major injury' },
  { slug: 'pregnancy_emergency', label: 'Pregnancy emergency' },
  { slug: 'child_emergency', label: 'Child emergency' },
  { slug: 'other', label: 'Other emergency' },
]
